export default "__VITE_ASSET__BtBw5i$x__"